import React, { FC, useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useField } from 'formik';
import { FieldLabel } from '../../fields/FieldLabel/FieldLabel';
import { useUser } from '../../../hooks/useUser';
import { isInternal } from '../../../utils';
import { FieldError } from '../../fields/FieldError/FieldError';
import { CustomSelectField } from '../../../pages/pro/applicationForm/customSelect';
import { getRMNOptions } from './helper';

export const RmnSelector: FC = () => {
  const { role, brand } = useUser();
  const [, field, { setValue }] = useField({ name: 'rmn_ids' });
  const [rmnOptions, setRMNOptions] = useState<any[]>([]);

  useEffect(() => {
    // Resolve the RMN brand by flag, not by position — the brand array has no
    // guaranteed order, so brand[0] may be a non-RMN brand for multi-brand users.
    const hasRmnBrand = brand?.some((b: any) => b?.rmn);
    const rmnBrand = brand?.find((b: any) => b?.rmn) || brand?.[0];
    if (isInternal(role) && !hasRmnBrand) {
      getRMNOptions().then(setRMNOptions);
    } else {
      setRMNOptions([{ label: rmnBrand?.name, value: rmnBrand?.id }]);
      setTimeout(() => setValue([rmnBrand?.id]), 200);
    }
  }, [brand]);

  return (
    <Stack>
      <FieldLabel>Network</FieldLabel>
      <CustomSelectField
        name="rmn_ids"
        label=""
        renderValue={(selected) => {
          const selectedRMNs = rmnOptions.filter((option) =>
            selected.includes(option.value)
          );
          if (selectedRMNs.length === 0) return 'Select Network';
          return selectedRMNs.map((o) => o.label).join(', ');
        }}
        placeholder="Select Network"
        options={rmnOptions}
        noLabel
        disabled={Boolean(brand?.some((b: any) => b?.rmn))}
      />

      {field.error && field.touched && <FieldError>{field.error}</FieldError>}
    </Stack>
  );
};
